import React from "react";
import CustomTable from "../../../../../components/table/CustomTable";
import {VisitorHistoryTableApp} from "../Functionality/VisitorHistoryTableApp";
import IncomingInvitationDetailsModal from "../../Invitation/Modal/IncomingInvitationDetailsModal";
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
import {INVITATION_VIEW_TYPE} from "../../Invitation/Model/Model";
import InvitationDetailsModal from "../../Invitation/Modal/InvitationDetailsModal";
import {TABS_VISITOR_UPDATE} from "../Model/Model";
import routes from "../../../../../Routes/routes";

/**
 * @email kpozos@ibl.mx
 * @author Karen Yunuen Pozos Arias
 * @title Full Stack Developer
 */

const VisitorHistoryTable = (props) => {
    const {item, location } = props;
    const {
        t,
        tableId,
        searchId,
        option,
        thead,
        tbody,
        simpleDetailsModal,
        setSimpleDetailsModal,
        completeDetailsModal,
        setCompleteDetailsModal,
        itemSelected,
        setItemSelected,
        setBodyForExport,
        searchElement,
        setSearchElement,
        setResults,
        rowsPerPage,
        setSimpleSearch,
        search,
        setSearch,
        pagination,
        getActionsButtons,
    } = VisitorHistoryTableApp({
        item
    });

    return (
        <>
            <SearchSimple
                id={searchId}
                setBodyForExport={setBodyForExport}
                setSearchResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSimpleSearch={setSimpleSearch}
                search={search}
                setSearch={setSearch}
                contractorId={item.id}
                supplierId={null}
                viewType={INVITATION_VIEW_TYPE.HISTORY}
            />
            <CustomTable
                tableId={tableId}
                checkbox={false}
                thead={thead}
                tbody={tbody}
                columnActions={true}
                getActionsButtons={getActionsButtons}
                childrenNotInformation={tbody?.data?.length === 0 ? <>
                        <div className={"warning-text"}>
                            <p>{t("no_invitations_found")}.</p>
                        </div>
                    </>
                    : undefined
                }
            />
            {pagination()}

            { itemSelected &&
                <>
                    { simpleDetailsModal &&
                        <IncomingInvitationDetailsModal
                            show={simpleDetailsModal}
                            onHide={() => {
                                setSimpleDetailsModal(false);
                                setItemSelected(null);
                            }}
                            itemSelected={itemSelected}
                        />
                    }
                    { completeDetailsModal &&
                        <InvitationDetailsModal
                            viewType={INVITATION_VIEW_TYPE.HISTORY}
                            backUrl={{
                                pathname: routes.visitor.update,
                                state: {
                                    ...location?.state,
                                    id: itemSelected.visitorId,
                                    currentTab: TABS_VISITOR_UPDATE.INVITATION_HISTORY.INDEX
                                }
                            }}
                            show={completeDetailsModal}
                            onHide={() => {
                                setCompleteDetailsModal(false);
                                setItemSelected(null);
                            }}
                            itemSelected={itemSelected}
                            showIdentityValidationButton={false}
                        />
                    }
                </>
            }
        </>
    );
};

export default VisitorHistoryTable;
